var React = require('react');

function HamburgerMenu (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"7.00024","y":"-0.000244141","width":"19.4998","height":"2.39996","rx":"1.19998","fill":"#30E4BE","key":0}),React.createElement("rect",{"x":"0.5","y":"8.7981","width":"25.9997","height":"2.39996","rx":"1.19998","fill":"#F8672A","key":1}),React.createElement("rect",{"x":"14.5835","y":"17.6001","width":"11.9165","height":"2.39996","rx":"1.19998","fill":"#30E4BE","key":2})]);
}

HamburgerMenu.defaultProps = {"width":"27","height":"20","viewBox":"0 0 27 20","fill":"none"};

module.exports = HamburgerMenu;

HamburgerMenu.default = HamburgerMenu;
